<template>
  <div style="font-size: 15px;">
    <table-other-models :car="car" :id="carId" :iframe="true"/>
  </div>
</template>


<script>
import TableOtherModels from "@/components/Dealers/TableOtherModels";
// import {mapActions} from "vuex";

export default {
  components: {
    TableOtherModels
  },
  mounted() {
    if (document.querySelector('.main .header')) {
      document.querySelector('.main .header').style.display = 'none';
    }

    if (document.querySelector('.mobile-sub-menu')) {
      document.querySelector('.mobile-sub-menu').style.display = 'none';
    }

    if (document.querySelector('#main.main')) {
      document.querySelector('#main.main').style.marginTop = '0px';
    }

    if (document.querySelector('.cookies-block')) {
      document.querySelector('.cookies-block').style.display = 'none';
    }

    this.$store.dispatch('dealers/FETCH_CAR', this.carId);
  },

  computed: {
    car() {
      // console.log('this.$store.state.NewCar;', this.$store.state.dealers.newCar);
      return this.$store.state.dealers.newCar;
    },
    carId() {
      return this.$route.params.id;
    }
  }
}
</script>
